var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3530_26446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3530_26446)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1924 10C12.9835 10 13.7569 9.76541 14.4147 9.32588C15.0725 8.88635 15.5851 8.26164 15.8879 7.53074C16.1906 6.79983 16.2699 5.99556 16.1155 5.21964C15.9612 4.44372 15.5802 3.73098 15.0208 3.17157C14.4614 2.61216 13.7487 2.2312 12.9727 2.07686C12.1968 1.92252 11.3925 2.00173 10.6616 2.30448C9.93074 2.60723 9.30602 3.11992 8.8665 3.77772C8.42697 4.43552 8.19238 5.20888 8.19238 6C8.19238 7.06087 8.6138 8.07828 9.36395 8.82843C10.1141 9.57857 11.1315 10 12.1924 10ZM2.85938 22C2.85937 19.5246 3.84272 17.1506 5.59309 15.4002C7.34346 13.6498 9.71748 12.6665 12.1929 12.6665C14.6683 12.6665 17.0423 13.6498 18.7927 15.4002C20.543 17.1506 21.5264 19.5246 21.5264 22H2.85938Z",
    fill: "#C3C3C3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyUser);
export default __webpack_public_path__ + "static/media/greyUser.feae5ad8b29e44f38991516e07abe2e2.svg";
export { ForwardRef as ReactComponent };